import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import ltData from './locales/lt.json';
import enData from './locales/en.json';

const lt = ltData;
const en = enData;

// Translation files loaded successfully

            i18n
              .use(LanguageDetector)
              .use(initReactI18next)
              .init({
                resources: {
                  lt: { translation: lt },
                  en: { translation: en }
                },
                lng: 'lt', // Force default language
                fallbackLng: 'lt',
                debug: false,
                interpolation: {
                  escapeValue: false
                },
                detection: {
                  order: ['localStorage', 'navigator'],
                  caches: ['localStorage']
                },
                reloadResources: true,
                partialBundledLanguages: true
              });

// i18n initialized successfully

export default i18n; 